import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getOrganizations, ORGANIZATIONS_QUERY_CONFIG, ORGANIZATIONS_QUERY_KEY } from '../api';
import type { Organization } from '../model';

type UseOrganizationResponse = UseQueryResult<Array<Organization>, Error>;
type UserId = Parameters<typeof getOrganizations>[0];

export function useOrganizations(userId?: UserId | undefined): UseOrganizationResponse {
  return useQuery([ORGANIZATIONS_QUERY_KEY, userId], () => getOrganizations(userId as UserId), {
    enabled: typeof userId !== 'undefined',
    ...ORGANIZATIONS_QUERY_CONFIG,
  });
}
